import React from 'react';

import { Icon } from '../icon/Icon';
import { UseTooltipProps } from '../tooltip';
import { SimpleTooltip } from '../tooltip/SimpleTooltip';

export const DefaultTriggerElement = () => <Icon glyph="info-circle" color="text-subdued" />;

type InfoIconProps = {
  /**
   * Allows to use custom trigger element.
   * `DefaultTriggerElement` can be reused in your custom trigger.
   */
  triggerElement?: React.ReactChild;
  className?: string;
  placement?: UseTooltipProps['placement'];
  'data-role'?: string;
};

export const InfoIcon: React.FC<InfoIconProps> = ({
  children,
  className,
  placement,
  triggerElement,
  'data-role': dataRole,
}) => {
  return (
    <SimpleTooltip
      disabled={children == null}
      placement={placement ?? 'bottom-center'}
      triggerDataRole={dataRole}
      triggerClassName={className}
      content={children}
    >
      {triggerElement || <DefaultTriggerElement />}
    </SimpleTooltip>
  );
};
